// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__ePJsB","footer":"ChangeClinic_footer__3Fygp"};